import { render, staticRenderFns } from "./VehicleInsuranceManageView.vue?vue&type=template&id=5e77b0c7&scoped=true&"
import script from "./VehicleInsuranceManageView.vue?vue&type=script&lang=js&"
export * from "./VehicleInsuranceManageView.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInsuranceManageView.vue?vue&type=style&index=0&id=5e77b0c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e77b0c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VForm,VRow})
